import React, {useEffect, useState} from "react";
import CouponList, {CouponItem} from "../../components/coupon";
import { getUserRegisterGift } from "../../service";

function NewUser(){

    const [lists,setLists] = useState<Array<CouponItem>>([])

    useEffect(() =>{
        getUserRegisterGift().then(res => {
            if(res.code === 1){
                setLists([res.data])
            }
        })
    },[])

    console.log(lists)

    return <div className="new-user">
        <CouponList dataLists={ lists } onCouponClick={(id) => console.log(id) }/>

        {/*<div className="btn">立即领取</div>*/}
    </div>
}

export default NewUser
